module.exports = __webpack_public_path__ + "static/img/shikan.6092ebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shikan.jpg
// module id = Ybk0
// module chunks = 1